module.exports = __webpack_public_path__ + "img/3.452c1872.png";